<template>
  <div>
    <v-carousel
        cycle
        interval="10000"
        :show-arrows="false"
        hide-delimiters
        max-height="300"
    >

      <v-carousel-item
          key="item-1"
          :src="getBackground"
      >
        <v-container fluid class="cta-container">
          <v-container class="contain-width">
            <v-sheet
                height="100%"
                width="100%"
                color="transparent"
                class="d-flex align-center flex-column justify-center carousel-sheet mt-3"
            >

                <v-row>
                  <v-col sm="6" lg="6" class="col-12">
                    <div class="d-flex flex-column align-center align-sm-left align-sm-start justify-center" style="height: 100%">
                      <h1 class="text-h4 text-sm-h4 text-md-h4 text-lg-h3 text-xl-h2 text-center text-sm-left text-uppercase mb-6 mt-6 mt-sm-3">
                        <span class="text-uppercase primary--text">{{ $t("Tag it") }}</span><br>
                        <span class="text-uppercase white--text">{{ $t("Scan it") }}</span><br>
                        <span class="text-uppercase primary--text">{{ $t("Find it") }}</span>
                      </h1>
                      <p class="text-h5 text-sm-h6 text-md-h6 text-lg-h5 text-xl-h4 text-center text-sm-left white--text">{{ $t("Once a {brand} is scanned an instant notification is sent to your phone", {brand: brandName}) }}.</p>

                    </div>

                  </v-col>
                  <v-col sm="6" lg="6" class="d-none d-sm-block text-right">

                      <v-img
                          :src="getBannerOverlay(1)"
                          :max-width="500"
                          contain
                          class="bg-grey-lighten-2 ml-auto"
                      ></v-img>

                  </v-col>
                </v-row>


              <p class="mt-0">
                <v-btn color="primary" class="d-block d-sm-none cta-x-large textOnPrimary--text" @click="navigate('individuals')">{{ $t('buttons.Subscribe') }}</v-btn>
                <v-btn x-large color="primary" class="d-none d-sm-block cta-x-large textOnPrimary--text" @click="navigate('individuals')">{{ $t('buttons.Subscribe') }}</v-btn>
              </p>

            </v-sheet>
          </v-container>
        </v-container>

      </v-carousel-item>
      <v-carousel-item
          key="item-2"
          :src="getBackground"
      >
        <v-container fluid class="cta-container">
          <v-container class="contain-width">
            <v-sheet
                height="100%"
                width="100%"
                color="transparent"
                class="d-flex align-center flex-column justify-center carousel-sheet mt-3"
            >

              <v-row>
                <v-col sm="6" lg="6" class="col-12">
                  <div class="d-flex flex-column align-center align-sm-left align-sm-start justify-center" style="height: 100%">
                    <h1 class="text-h4 text-sm-h4 text-md-h4 text-lg-h3 text-xl-h2 text-center text-sm-left text-uppercase mb-6 mt-6 mt-sm-3">
                      <span class="text-uppercase primary--text">{{ $t("Recovery card") }}</span><br>
                      <span class="text-uppercase white--text">{{ $t("for wallets") }}</span>
                    </h1>
                    <p class="text-h5 text-sm-h6 text-md-h6 text-lg-h5 text-xl-h4 text-center text-sm-left white--text">{{ $t("Add one of our {brand} recovery cards inside your wallet so it can be easily scanned if lost", {brand: brandName}) }}.</p>

                  </div>

                </v-col>
                <v-col sm="6" lg="6" class="d-none d-sm-block text-right">

                  <v-img
                      :src="getBannerOverlay(2)"
                      :max-width="500"
                      contain
                      class="bg-grey-lighten-2 ml-auto"
                  ></v-img>

                </v-col>
              </v-row>

              <p class="mt-10">
                <v-btn color="primary" class="d-block d-sm-none cta-x-large textOnPrimary--text" @click="navigate('individuals')">{{ $t('buttons.Subscribe') }}</v-btn>
                <v-btn x-large color="primary" class="d-none d-sm-block cta-x-large textOnPrimary--text" @click="navigate('individuals')">{{ $t('buttons.Subscribe') }}</v-btn>
              </p>

            </v-sheet>
          </v-container>
        </v-container>

      </v-carousel-item>
      <v-carousel-item
          key="item-3"
          :src="getBackground"
      >
        <v-container fluid class="cta-container">
          <v-container class="contain-width">
            <v-sheet
                height="100%"
                width="100%"
                color="transparent"
                class="d-flex align-center flex-column justify-center carousel-sheet mt-3"
            >

              <v-row>
                <v-col sm="6" lg="6" class="col-12">
                  <div class="d-flex flex-column align-center align-sm-left align-sm-start justify-center" style="height: 100%">
                    <h1 class="text-h4 text-sm-h4 text-md-h4 text-lg-h3 text-xl-h2 text-center text-sm-left text-uppercase mb-6 mt-6 mt-sm-3"><span class="text-uppercase primary--text">{{ $t("A revolutionary way") }}</span><br><span class="white--text">{{ $t("to find what's yours") }}</span></h1>
                    <p class="text-h5 text-sm-h6 text-md-h6 text-lg-h5 text-xl-h4 text-center text-sm-left white--text">{{ $t("{brand} is a solution to the vast and expensive problem of lost property", {brand: brandName}) }}.</p>

                  </div>

                </v-col>
                <v-col sm="6" lg="6" class="d-none d-sm-block text-right">

                  <v-img
                      :src="getBannerOverlay(3)"
                      :max-width="500"
                      contain
                      class="bg-grey-lighten-2 ml-auto"
                  ></v-img>

                </v-col>
              </v-row>

              <p class="mt-10">
                <v-btn color="primary" class="d-block d-sm-none cta-x-large textOnPrimary--text" @click="navigate('individuals')">{{ $t('buttons.Subscribe') }}</v-btn>
                <v-btn x-large color="primary" class="d-none d-sm-block cta-x-large textOnPrimary--text" @click="navigate('individuals')">{{ $t('buttons.Subscribe') }}</v-btn>
              </p>

            </v-sheet>
          </v-container>
        </v-container>

      </v-carousel-item>
    </v-carousel>

    <v-container fluid class="white">
      <v-container class="contain-width">
        <v-row>
          <v-col>
            <p class="grey--text text--darken-2 text-h6 mt-6 intro">{{ $t('{brand} homepage-intro', {brand: brandName}) }}</p>
          </v-col>
        </v-row>
        <v-row class="steps">
          <v-col class="col-12 col-sm-4">
            <h3 class="text-center">1 {{ $t('buttons.Activate') }}</h3>
            <p class="text-h6 pt-6">
              {{ $t('Activate your tag before use on our website by logging into your account and clicking the icon') }}
                <v-img
                    width="80px"
                    :src="activ8Logo"
                    eager
                    class="d-inline-block"
                    style="margin-bottom: -5px"
                >
                </v-img>
            </p>
          </v-col>
          <v-col class="col-12 col-sm-4">
            <h3>2 {{ $t('headings.Tag Items') }}</h3>
            <p class="text-h6 pt-6">{{ $t('Attach the tag to your item securely.') }} <router-link :to="{ name: 'guide', params: {slug: 'ironing-on-tags'} }">{{ $t('See our guide to learn how to use your iron on smart tags.') }}</router-link></p>
          </v-col>
          <v-col class="col-12 col-sm-4">
            <h3>3 {{ $t('headings.Found Items') }}</h3>
            <p class="text-h6 pt-6">{{ $t('When an item is found and scanned you will receive an instant email/sms notification.') }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-12 col-md-6">
            <v-card height="100%" class="pa-3" color="background">
              <v-card-text>
                <div class="d-flex flex-column flex-sm-row justify-space-between">
                  <div>
                    <h2 class="text-uppercase text-h4 mb-6 mr-sm-6">
                      <span class="primary--text">{{ $t('Account') }}</span><br>{{ $t('features') }}
                    </h2>
                    <div class="d-none d-sm-flex justify-end">
                      <p>
                      <v-img
                          v-if="brand === 'neotag'"
                          :src="require('@/assets/arrow-blue.png')"
                          :width="200"
                          cover
                          class="bg-grey-lighten-2"
                      ></v-img>
                        <v-img
                            v-else
                            :src="require('@/assets/arrow-pink.png')"
                            :width="200"
                            cover
                            class="bg-grey-lighten-2"
                        ></v-img>
                      </p>
                    </div>

                  </div>
                  <ul class="mb-6 text-h6">
                    <li>{{ $t("Unlimited SMS notifications for found items") }}</li>
                    <li>{{ $t("Refer a friend commission") }}</li>
                    <li>{{ $t("Free use of our app (android/ios)") }}</li>
                    <li>{{ $t("Optional partner offers (opt in)") }}</li>
                  </ul>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="col-12 col-md-6">
            <v-card height="100%" class="pa-3" color="background">
              <v-card-text>
                <div class="d-flex flex-column flex-sm-row justify-space-between">
                  <div style="width: 50%">
                    <h2 class="text-uppercase text-h4 mb-6 mr-sm-6">
                      <span class="primary--text">{{ $t('Free bundle') }}</span><br><span class="primary--text">{{ $t('of') }}</span> {{ tagName }}
                    </h2>
                    <div class="d-none d-sm-flex justify-end">
                      <p>
                        <v-img
                            v-if="brand === 'neotag'"
                            :src="require('@/assets/arrow-blue.png')"
                            :width="200"
                            cover
                            class="bg-grey-lighten-2"
                        ></v-img>
                        <v-img
                            v-else
                            :src="require('@/assets/arrow-pink.png')"
                            :width="200"
                            cover
                            class="bg-grey-lighten-2"
                        ></v-img>
                      </p>
                    </div>
                  </div>
                  <ul class="mb-6 text-h6">
                    <li>{{ $t("{quantity} iron on labels", {quantity: '25'}) }}</li>
                    <li>{{ $t("{quantity} sticker labels", {quantity: '25'}) }}</li>
                    <li>{{ $t("{quantity} key tags", {quantity: '3'}) }}</li>
                    <li>{{ $t("{quantity} two part bag tag", {quantity: '1'}) }}</li>
                    <li>{{ $t("{quantity} recovery card", {quantity: '1'}) }}</li>
                  </ul>
                </div>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>



    <v-container fluid class="white">
      <v-container class="contain-width">
        <v-row class="pr-3 pl-3 d-none d-md-flex">
          <v-col
              v-for="n in 6"
              :key="n"
              class="d-flex child-flex pl-0 pr-0"
              cols="2"
          >
            <v-img
                v-if="brand === 'neotag'"
                :src="require('@/assets/neotag-product' + n + '.jpg')"
                aspect-ratio="1"
                cover
                class="lifestyle-square bg-grey-lighten-2"
            >
              <template v-slot:placeholder>
                <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                >
                  <v-progress-circular
                      indeterminate
                      color="grey-lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-img
                v-else
                :src="require('@/assets/findmykit-lifestyle-' + n + '.png')"
                aspect-ratio="1"
                cover
                class="lifestyle-square bg-grey-lighten-2"
            >
              <template v-slot:placeholder>
                <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                >
                  <v-progress-circular
                      indeterminate
                      color="grey-lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
        </v-row>

        <v-row class="pr-3 pl-3 d-flex d-md-none mt-0">
          <v-col
              v-for="n in 3"
              :key="n"
              class="d-flex child-flex pl-0 pr-0 pt-0"
              cols="4"
          >
            <v-img
                v-if="brand === 'neotag'"
                :src="require('@/assets/neotag-product' + n + '.jpg')"
                aspect-ratio="1"
                cover
                class="lifestyle-square bg-grey-lighten-2"
            >
              <template v-slot:placeholder>
                <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                >
                  <v-progress-circular
                      indeterminate
                      color="grey-lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-img
                v-else
                :src="require('@/assets/findmykit-lifestyle-' + n + '.png')"
                aspect-ratio="1"
                cover
                class="lifestyle-square bg-grey-lighten-2"
            >
              <template v-slot:placeholder>
                <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                >
                  <v-progress-circular
                      indeterminate
                      color="grey-lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <v-container v-if="!authenticated || (authenticated && !user.bundle_claimed_at && !hasActiveTrial && !user.membership)" fluid class="white">
      <v-container class="contain-width">
        <v-row>
          <v-col cols="12">
            <v-card
                class="mx-auto product-card"
                outlined
                :elevation="hover ? 4 : 4"
            >
              <v-card-text>
                <v-row>
                  <v-col class="col-12 col-md-8">
                    <h1 class="headline primary--text pl-3 pt-0 pt-sm-3">{{ $t('headings.Get your subscription and claim your FREE bundle') }}</h1>
                    <h2 class="text-subtitle-1 mt-3 mb-6 pl-3">{{ $t("You must have an active subscription to receive alerts, purchase new products, or activate tags") }}.</h2>

                    <IndividualsSummary/>

                  </v-col>
                  <v-col class="col-12 col-md-4 text-right">
                    <v-img :aspect-ratio="1/1" v-if="brand === 'neotag'" contain class="mt-4 mr-0 mr-sm -6"
                           src="https://findmykit-images.s3-eu-west-1.amazonaws.com/neotag-bundle.png"></v-img>
                    <v-img :aspect-ratio="1/1" v-else contain class="mt-4 mr-6"
                           src="https://findmykit-images.s3-eu-west-1.amazonaws.com/personal-bundle.png"></v-img>
                  </v-col>
                </v-row>
              </v-card-text>





              <v-card-text>
                <div class="d-flex flex-column flex-sm-row pl-0 pb-0 pl-sm-3 pb-sm-3">
                  <v-btn v-if="authenticated && !!user.stripe_subscription === false" class="mt-3 mr-sm-3" x-large elevation="0" color="primary" @click="membershipDialog = true">{{ $t('buttons.Subscribe now') }}</v-btn>
                  <v-btn v-if="authenticated && !user.bundle_claimed_at" class="mt-3 mr-sm-3" x-large elevation="0" dark color="green" @click="navigate('basket')">{{ $t('buttons.Claim free bundle now') }}</v-btn>
                  <v-btn v-if="!authenticated" class="mt-3 mr-sm-3" elevation="0" color="primary" @click="navigate('sign-up-individual')">{{ $t('buttons.Sign up as individual') }}</v-btn>
                  <v-btn v-if="!authenticated" class="mt-3" elevation="0" color="primary" @click="navigate('login')">{{ $t('buttons.Login to add subscription') }}</v-btn>
                </div>

              </v-card-text>


            </v-card>

            <v-dialog
                v-model="membershipDialog"
                max-width="600"
            >
              <v-card>
                <v-card-title class="headline primary">
                  {{ $t('headings.Subscription') }}
                </v-card-title>

                <v-card-text>
                  <MembershipForm v-on:close-form="closeForm"/>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                      color="primary"
                      text
                      @click="membershipDialog = false"
                  >
                    {{ $t('buttons.Close') }}
                  </v-btn>
                </v-card-actions>
              </v-card>

            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <v-container fluid class="white">
      <v-container class="contain-width">
        <v-row>
          <v-col md="12">
            <h3 class="text-h4 text-sm-h3 text-center"><span class="primary--text" v-if="locale === 'en'">{{brandName}}</span> <span class="black--text text-uppercase">{{ $t('headings.Products') }} <span class="primary--text" v-if="locale === 'es'">{{brandName}}</span> - {{ $t('headings.Best Sellers') }}</span></h3>
          </v-col>
        </v-row>
        <v-row v-if="products">
          <v-col
              v-for="(product, i) in products"
              :key="'popular-' + i"
              class="col-12 col-md-6"
          >
            <v-card
                class="mx-auto"
                flat
                light
                color="#eee"
                style="height: 100%"
            >
              <v-row>
                <v-col class="col-12">
                  <v-img
                      v-if="product.product_images.length > 0"
                      class="white--text align-start ml-3 mr-3"
                      contain
                      :src="product.product_images[0].path"
                  >

                  </v-img>
                </v-col>
                <v-col class="col-12">
                  <v-card-text class="text--black">

                    <h3 class="text-body-1 font-weight-bold">{{product.name}}</h3>
                    <p class="font-weight-black subtitle-1">{{ brand === 'neotag' ? '€' : '£'}}{{product.price}}</p>

                    <div class="body-1 mb-6">{{truncate(product.description, 100)}}</div>

                    <h3 class="text-body-1 font-weight-bold mb-3" v-if="keyPoints(product).length > 0">{{ $t('headings.Key points') }}</h3>

                    <ul class="text-body-1 mb-6">
                      <li v-for="(point, i) in keyPoints(product)"
                          :key="i">{{point}}</li>
                    </ul>

                    <p class="text-right">
                      <v-btn color="primary" class="textOnPrimary--text" @click="navigate('product', {slug: product.slug})">{{ $t('links.Read more') }}</v-btn>
                    </p>

<!--                    <p>-->
<!--                      <v-img-->
<!--                          v-if="product.activate == 1"-->
<!--                          class="white&#45;&#45;text float-right"-->
<!--                          width="80px"-->
<!--                          :src="activ8Logo"-->
<!--                          eager-->
<!--                      >-->
<!--                      </v-img>-->
<!--                    </p>-->

                  </v-card-text>
                </v-col>
              </v-row>






            </v-card>


          </v-col>
          <v-col class="text-center">
            <v-btn x-large class="textOnPrimary--text" elevation="0" @click="navigate('products')" color="primary">{{ $t('buttons.Shop now') }}</v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col
              class="col-12 col-md-6"
              v-for="(item, i) in 2"
              v-bind:key="'loader-' + i"
          >
            <v-sheet
                :color="`grey lighten-4`"
                class="px-3 pt-3 pb-3"
            >
              <v-skeleton-loader
                  class="mx-auto"
                  type="card"
              ></v-skeleton-loader>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-container>




<!--    <v-container fluid class="grey-container">-->
<!--      <v-container class="contain-width">-->
<!--        <v-row>-->
<!--          <v-col :md="6" :sm="12">-->
<!--            <v-sheet :color="sheetColor" class="pt-6 pb-6">-->
<!--              <a v-if="brand === 'neotag'" class="twitter-timeline" :data-theme="theme" data-height="500" href="https://twitter.com/neotagspain?ref_src=twsrc%5Etfw">Tweets by Neotag</a>-->
<!--              <a v-else class="twitter-timeline" :data-theme="theme" data-height="500" href="https://twitter.com/FindMyKit?ref_src=twsrc%5Etfw">Tweets by findmykit</a>-->
<!--            </v-sheet>-->
<!--          </v-col>-->
<!--          <v-col :md="6" :sm="12">-->
<!--            <div class="text-center">-->
<!--              <v-sheet :color="sheetColor" class="pt-6 pb-6">-->
<!--                <div v-if="brand === 'neotag'" class="fb-page" data-href="https://www.facebook.com/neotagspain" data-tabs="timeline" data-width="500" data-height="500" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="false"><blockquote cite="https://www.facebook.com/neotagspain" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/neotagspain">Facebook posts by Neotag</a></blockquote></div>-->
<!--                <div v-else class="fb-page" data-href="https://www.facebook.com/FindMyKit" data-tabs="timeline" data-width="500" data-height="500" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="false"><blockquote cite="https://www.facebook.com/FindMyKit" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/FindMyKit">Facebook posts by findmykit</a></blockquote></div>-->
<!--              </v-sheet>-->
<!--            </div>-->
<!--          </v-col>-->
<!--        </v-row>-->

<!--      </v-container>-->
<!--    </v-container>-->

    <Footer />
    <CookieAcceptDecline />
  </div>


</template>

<script>

import {gmapApi} from 'vue2-google-maps'

let pic1 = require('@/assets/IMG_3382.jpg')
let pic2 = require('@/assets/IMG_2559.jpg')
let pic3 = require('@/assets/IMG_2776.jpg')
let pic4 = require('@/assets/IMG_3300.jpg')
let individual = require('@/assets/label-property.jpg')
let organisation = require('@/assets/lost-property.jpg')

import axios from 'axios';

import Footer from './Footer'
import CookieAcceptDecline from './CookieAcceptDecline'
import {i18n} from "../i18n";
import IndividualsSummary from "./IndividualsSummary";
import MembershipForm from './MembershipForm'
//import OrganisationsSummary from "./OrganisationsSummary";
import {mapGetters, mapState} from "vuex";

export default {
  name: "Home",
  metaInfo() {
    return {
      title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t("A revolutionary way to find what's yours"),
      htmlAttrs: {
        lang: i18n.locale
      },
      meta: [
        { name: 'description', content: i18n.t("{brand} is a solution to the vast and expensive problem of lost property", {brand: this.brandName}) + '. ' + i18n.t("A revolutionary way to find what's yours")}
      ]
    }
  },
  props: ['offsetTop'],
  data () {
    return {
      hover: false,
      membershipDialog: false,
      stripeKey: process.env.VUE_APP_STRIPE_KEY,
      alert: true,
      videoID: '410322496',
      height: 1000,
      options: {'responsive': true, 'dnt': true},
      playerReady: false,
      pic1: pic1,
      pic2: pic2,
      pic3: pic3,
      pic4: pic4,
      individual: individual,
      organisation: organisation,
      markers: [],
      places: [],
      currentPlace: null,
      products: null,
      show: false,
      locations: [],
      icons: {},
      infowindow: null,
      place: null,
      zoom: 9,
      mapLoading: false,
      socialLoading: false
    }
  },
  components: {
    'Footer': Footer,
    'CookieAcceptDecline': CookieAcceptDecline,
    IndividualsSummary,
    MembershipForm
  },
  computed: {
    ...mapGetters('account', ['hasMembership', 'hasActiveTrial']),
    ...mapState({
      authenticated: state => state.authenticated,
      user: state => state.account.user,
      locale: state => state.locale,
      brand: state => state.brand,
      brandName: state => state.brandName
    }),
    google: gmapApi,
    tagName() {
      if (this.brand === 'neotag') {
        return 'NEOTAGS'
      }
      return 'SMART TAGS'
    },
    center() {
      if (this.brand === 'neotag') {
        return { lat: 39.4, lng: -0.4 }
      }
      return { lat: 51.2, lng: 0.5 }
    },
    cardWidth() {
      console.log(screen.width)
      if (screen.width <= 600) {
        //return (screen.width * 0.9) + 'px'
        return '100%'
      }
      return '600px'
    },
    getBackground() {
      return require('@/assets/neotag-background.jpg')
    },
    activ8Logo() {
      if (this.brand === 'neotag') {
        return require('@/assets/activ8-logo-alpha-dark.png')
      }
      return require('@/assets/activ8-logo.png')
    },
    isLight() {
      return Boolean(this.brand !== 'neotag')
    },
    bundlePrice() {
      if (this.brand === 'neotag') {

        return '€34.80'
      }

      return '£34.80'
    },
    subscriptionPrice() {
      if (this.brand === 'neotag') {
        return '€' + process.env.VUE_APP_SUBSCRIPTION_EUR
      }

      return '£' + process.env.VUE_APP_SUBSCRIPTION_GBP
    },
    sheetColor() {
      if (this.brand === 'neotag') {
        return '#292F33'
      }

      return 'white'
    },
    theme() {
      if (this.brand === 'neotag') {
        return 'dark'
      }

      return 'light'
    }
  },
  watch: {
    locale (to, from){
      if (to !== from) {
        this.loadBestProducts()
      }
    }
    // offsetTop (val) {
    //
    //   if (val > 1837 && this.mapLoading === false) {
    //     this.mapLoading = true
    //     console.log("map loading")
    //
    //     let apiClient = axios.create({
    //       baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
    //       withCredentials: true,
    //     });
    //
    //     apiClient.get('/sanctum/csrf-cookie').then(() => {
    //       apiClient
    //           .get('/api/organisations/coordinates')
    //           .then(response => {
    //             if (response.status === 200) {
    //               let organisations = response.data.data
    //               for (let key in response.data.data) {
    //                 let category = 'other';
    //                 if (organisations[key].organisation_category) {
    //                   category = organisations[key].organisation_category.slug
    //                 }
    //                 this.locations.push([organisations[key].name, organisations[key].latitude, organisations[key].longitude, 4, category])
    //               }
    //               this.doMap()
    //             }
    //           })
    //           .catch(error => {
    //             console.log(error)
    //           })
    //           .finally(() => this.show = true)
    //     })
    //   }
    //   if (val > 2456 && this.socialLoading === false) {
    //     this.socialLoading = true;
    //
    //     /* eslint-disable */
    //     (function (d, s, id) {
    //       var js, fjs = d.getElementsByTagName(s)[0],
    //           t = window.twttr || {};
    //       if (d.getElementById(id)) return t.widgets.load();
    //       js = d.createElement(s);
    //       js.id = id;
    //       js.src = "https://platform.twitter.com/widgets.js";
    //       fjs.parentNode.insertBefore(js, fjs);
    //
    //       t._e = [];
    //       t.ready = function (f) {
    //         t._e.push(f);
    //       };
    //       return t;
    //     }(document, "script", "twitter-wjs"));
    //     /* eslint-enable */
    //
    //     const facebook = document.createElement("script");
    //     facebook.setAttribute(
    //         "src",
    //         "https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v6.0"
    //     );
    //     facebook.async = true;
    //     document.head.appendChild(facebook);
    //   }
    // }
  },
  mounted () {

    // redirect for hash route such as /#/found/:qrCode
    let hash = location.hash;
    if (hash.includes('found/') && hash !== '') {
      this.$router.push({name: 'dashboard-found', params: { qrCode: hash.substring(hash.lastIndexOf('/') + 1)  }})
    }

    this.$gtag.pageview({
      page_path: '/'
    })

    console.log('this is current player instance object', this.player)

    // this.locations = [
    //     ['Info', 51.188178, 0.244177, 4, 'educational'],
    // ];

    document.getElementById("scrolling-content").scrollTop = 0

    this.loadBestProducts()
  },
  methods: {
    closeForm() {
      this.membershipDialog = false
    },
    getBannerOverlay(slide) {
      if (this.brand === 'neotag') {
        if (slide === 1) {
          return require('@/assets/phone-neotag-banner.png')
        }
        else if (slide === 2) {
          return require('@/assets/recovery-card-neotag-banner.png')
        }
        else if (slide === 3) {
          return require('@/assets/keytags-neotag-banner.png')
        }
      }
      else {
        if (slide === 1) {
          return require('@/assets/phone-findmykit-banner.png')
        }
        else if (slide === 2) {
          return require('@/assets/recovery-card-fmk-banner.png')
        }
        else if (slide === 3) {
          return require('@/assets/keytags-findmykit-banner.png')
        }
      }
    },
    loadBestProducts() {
      this.show = false

      const instance = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale}
      });

      instance
          .get('/api/products/best?brand=' + this.brand)
          .then(response => {
            this.products = response.data.data
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.show = true
            window.prerenderReady = true;
          })
    },
    keyPoints(product) {

      if (product.points) {
        return product.points.split("\n")
      }

      return [];
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    onReady() {
      this.playerReady = true
    },
    play () {
      this.$refs.player.play()
    },
    stop () {
      this.$refs.player.stop()
    },
    // doMap () {
    //   // http://kml4earth.appspot.com/icons.html
    //   let iconBase = 'https://maps.google.com/mapfiles/kml/paddle/';
    //
    //   var marker, i;
    //
    //   let markers = [];
    //
    //   //var icons = this.icons;
    //   var infowindow
    //
    //   function addMarkerWithTimeout(location, timeout, map, google, icons) {
    //
    //     window.setTimeout(function() {
    //
    //       if (location[4] && location[1] && location[2]) {
    //         marker = new google.maps.Marker({
    //           position: new google.maps.LatLng(location[1], location[2]),
    //           map: map,
    //           icon: icons[location[4]].icon,
    //           animation: google.maps.Animation.DROP
    //         });
    //
    //         markers.push(marker);
    //
    //         google.maps.event.addListener(marker, 'click', (function(marker, i) {
    //           return function() {
    //             infowindow.setContent(location[0]);
    //             infowindow.open(map, marker);
    //           }
    //         })(marker, i));
    //       }
    //
    //     }, timeout);
    //
    //   }
    //
    //
    //
    //
    //
    //   this.$refs.mapRef.$mapPromise.then((map) => {
    //     infowindow = new this.google.maps.InfoWindow();
    //
    //     this.icons = {
    //       educational: {
    //         name: 'Educational',
    //         icon: {
    //           url: iconBase + 'red-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       },
    //       travel: {
    //         name: 'Transport & travel',
    //         icon: {
    //           url: iconBase + 'grn-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       },
    //       sports: {
    //         name: 'Sports and leisure',
    //         icon: {
    //           url: iconBase + 'blu-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       },
    //       retail: {
    //         name: 'Retail',
    //         icon: {
    //           url: iconBase + 'pink-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       },
    //       super: {
    //         name: 'Super partner',
    //         icon: {
    //           url: iconBase + 'ylw-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       },
    //       other: {
    //         name: 'Other',
    //         icon: {
    //           url: iconBase + 'wht-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       }
    //     };
    //
    //     let legend = document.getElementById('legend');
    //     for (let key in this.icons) {
    //       let type = this.icons[key];
    //       let name = type.name;
    //       let icon = type.icon.url;
    //       let div = document.createElement('div');
    //       div.style.color = 'black';
    //       div.className = "pin-div";
    //       div.innerHTML = '<img src="' + icon + '" width="30"> ' + name;
    //       legend.appendChild(div);
    //     }
    //
    //     //map.panTo({lat: 1.38, lng: 103.80})
    //     map.controls[this.google.maps.ControlPosition.RIGHT_BOTTOM].push(legend);
    //     for (i = 0; i < this.locations.length; i++) {
    //       addMarkerWithTimeout(this.locations[i], i * 200, map, this.google, this.icons);
    //     }
    //   })
    // },
    navigate (routeName, params) {
      this.$router.push({name: routeName, params: params})
    },
    // receives a place object via the autocomplete component
    // setPlace(place) {
    //     this.currentPlace = place;
    // },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    setDescription(description) {
      this.description = description;
    },
    setPlace(place) {
      this.place = place
      this.usePlace()
    },
    usePlace() {
      // https://github.com/xkjyeah/vue-google-maps/blob/vue2/examples/autocomplete.html
      if (this.place) {
        // this.markers.push({
        //     position: {
        //         lat: this.place.geometry.location.lat(),
        //         lng: this.place.geometry.location.lng(),
        //     }
        // })
        const marker = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.place = null;
        this.center = marker;
        this.zoom = 11
      }
    },
    downloadPdf() {
      axios({
        url: '/degradable-stock-spec-sheet.pdf',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'degradable-stock-spec-sheet.pdf');
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
    truncate (description, length) {
      if (description.length > length) {
        return description.substring(0, length) + '...';
      } else {
        return description;
      }
    }
  }
}
</script>

<style scoped>

.steps h3 {
  color: var(--v-textOnPrimary);
  background-color: var(--v-primary-base);
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 2.145em;
  text-transform: uppercase;
  display: inline-block;
}
.steps p {
  color: black;
}
.steps p a {
  color: black;
  text-decoration: none;
}
.steps p a:hover {
  text-decoration: underline;
}

.cta-button:hover {
  color: #fff !important;
  text-decoration: none !important;
}
.slider-card {
  /*background-color: #fff;*/
  border-radius: 15px;
}
/*.cta-card {*/
/*  border-radius: 15px;*/
/*}*/
/*.cta-card-img {*/
/*  border-top-size: 5px;*/
/*  border-top-color: #E6E6E6;*/
/*  border-top-style: solid;*/
/*}*/
/*.cta-container {*/
/*  margin-top: -24px;*/
/*}*/
/*.cta-x-large {*/
/*  !*border-radius: 15px;*!*/
/*  padding-left: 50px !important;*/
/*  padding-right: 50px !important;*/
/*}*/
/*.cta-card .v-card__text, .v-card__actions {*/
/*  background-color: #E6E6E6;*/
/*  padding-left: 0;*/
/*  padding-right: 0;*/
/*}*/
button.mt-10 {
  border-radius: 12px;
  text-transform: none;
  font-weight: bold;
}
.carousel-sheet h1 {
  /*font-family: 'Lato', sans-serif !important;*/
  /*font-size: 3em;*/
  text-shadow: 2px 2px 4px black;
}
.v-application .display-1, .v-application .headline, .v-application div {
  font-family: 'Lato', sans-serif !important;
}
.v-application .display-1, .v-application .headline {
  font-weight: bold;
}
#legend {
  font-family: Arial, sans-serif !important;
  background: #fff;
  padding: 10px;
  margin: 10px;
  border: 3px solid #000;
}
#legend h3 {
  margin-top: 0;
}
#legend div {
  margin-bottom: 5px !important;
}
#legend img {
  vertical-align: middle;
}
.player-container {
  width: 100% !important;
}
.product-card {
  height: 100%;
  padding: 12px;
  border: inherit;
  /*padding-bottom: 60px;*/
}
.product-card .v-card__actions {
  padding-left: 15px;
  padding-bottom: 15px;
  position: absolute;
  bottom: 0;
}
.gradient1 {
  background: rgb(63,94,251);
  background: radial-gradient(circle, rgba(63,94,251,1) 0%, rgba(252,70,107,1) 100%);
}
#legend h3, #legend div {
  color: black !important;
}
.intro {
  font-weight: normal !important;
}
.lifestyle-square {
  margin: 1px;
}
</style>
